// ###############################在线聊天模块接口################# start
import ajax from './index'
import apiEnv from './apiEnv'
//工单群详情
export function GetJobGroupInfo(params) {
    return ajax.post(`${apiEnv.api1}/api/Im/GetJobGroupInfo`, params)
}
//获取邀请用户列表
export function GetInviteUsers(params) {
    return ajax.post(`${apiEnv.api1}/api/Im/GetInviteUsers`, params)
}
//添加群成员
export function AddGroupMember(params) {
    return ajax.post(`${apiEnv.api1}/api/Im/AddGroupMember`, params)
}
//移除群成员
export function DeleteGroupMember(params) {
    return ajax.post(`${apiEnv.api1}/api/Im/DeleteGroupMember`, params)
}
//服务站替工程师提交服务报告
export function PcEngineerSubmitJobReport(params) {
    return ajax.post(`/JobWorkflow/PickJobCenter/PcEngineerSubmitJobReport`, params)
}
//更换工程师
export function ChangeJobEngineer(params) {
    return ajax.post(`/JobWorkflow/PickJob/ChangeJobEngineer`, params)
}
//电话外呼
export function AXBindPhone(params) {
    return ajax.post(`${apiEnv.api1}/api/BpoPrivateNumber/AXBindPhone`, params)
}
//是否显示聊天按钮
export function isShowChatBtnFun(params) {
    return ajax.post(`${apiEnv.api1}/api/Im/GetJointGroups`, params)
}
//修改群组信息
export function ChangGroupInfo(params) {
    return ajax.post(`${apiEnv.api4}/api/IM/ChangGroupInfo`, params)
}
//单聊列表
export function GetUserSingleChats(params) {
    return ajax.post(`${apiEnv.api1}/api/Im/GetUserSingleChats`, params)
}
//群聊列表
export function GetJointGroups(params) {
    return ajax.post(`${apiEnv.api1}/api/Im/GetJointGroups`, params)
}
//用户信息
export function GetUserImInfo(params) {
    return ajax.post(`${apiEnv.api1}/api/Im/GetUserImInfo`, params)
}
//获取用户信息
export function GetAccountData(params) {
    return ajax.post(`${apiEnv.api1}/api/UserCenter/GetAccountData`, params);
}
//获取权限和im名
export function GetAccountType(params) {
    return ajax.post(`${apiEnv.api1}/api/AppCompany/GetAccountType`, params);
}
//工单详情
export function pickOrderDetails(params) {
    return ajax.post(`${apiEnv.api1}/JobWorkflow/PickJob/GetWebPickJobInfo`, params);
}
//省市
export function GetAreas(params) {
    return ajax.post(`${apiEnv.api1}/ka/BpoServiceUser/GetArea`, params);
}
//企业承接
export function confirmPick(params) {
    return ajax.post(`${apiEnv.api1}/JobWorkflow/PickJob/ConfirmPickAndEnginee`, params);

}
//释放
export function releaseOrder(params) {
    return ajax.post(`${apiEnv.api1}/JobWorkflow/PickJob/ReleaseJo`, params);
}
//获取工程师下拉框（企业）
export function GetCompanyEngineer(params) {
    return ajax.post(`${apiEnv.api1}/JobWorkflow/PickJob/GetCompanyEnginee`, params);
}
//指定工程师
export function ConfirmEngineer(params) {
    return ajax.post(`${apiEnv.api1}/JobWorkflow/PickJob/ConfirmEngineer  `, params);
}
//获取工单的进度，用于刷新工单的进度
export function GetProgressList(params) {
    return ajax.post(`${apiEnv.api1}/JobWorkflow/PickJob/GetJobProgressLis`, params);
}
//添加服务进度 7=>工程师已出发 、 8=>工程师已到达现场
export function AddProgress(params) {
    return ajax.post(`${apiEnv.api1}/JobWorkflow/PickJob/AddJobProgres`, params);
}
// 获取环信用户信息
export function GetManagementImUser(params) {
    return ajax.post(`${apiEnv.api1}/api/AppCompany/GetManagementImUser`, params);
}
// ###############################在线聊天模块接口################# end

//发单方发送消息后
export function AddIMMessage(params) {
    return ajax.post(`${apiEnv.api1}/api/Im/AddIMMessage`, params)
}
//私聊判断是否可打开投标详情
export function IsRedirectBpoApplyOrder(params) {
    return ajax.post(`${apiEnv.api1}/api/JobApplyOrder/IsRedirectBpoApplyOrder`, params)
}
//证书类型和银行列表
export function CodeLines(params) {
    return ajax.post(`${apiEnv.api1}/api/Code/CodeLines`, params);
}
//获取所属行业列表
export function GetIndustry(params) {
    return ajax.get(`${apiEnv.api1}/api/BpoJob/GetIndustry`, params);
}
//获取领域
export function ProductDomains(params) {
    return ajax.get(`${apiEnv.api1}/api/Code/ProductDomains`, params);
}
//企业注册
export function IsShowChatButton(params) {
    return ajax.get(`${apiEnv.api1}/api/Im/IsShowChatButton`, params);
}
// 额度、余额信息
export function GetAccountFinanceInfo(params) {
    return ajax.get(`${apiEnv.api1}/api/Finance/GetAccountFinanceInfo`, params)
}